// covered-by: frontends/carrie/src/ask-v2/home/__tests__/ActionStack.test.tsx
import { type AskPunttActionCard } from "@mg/schemas/src/christo/askPunttBriefing";
import { Button, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type DigDeeperPanelProps = {
  card: AskPunttActionCard;
  onExpand: () => void;
};

export function DigDeeperPanel({ card, onExpand }: DigDeeperPanelProps) {
  const { t } = useTranslation("ui");

  return (
    <section
      data-testid="ask-v2-dig-deeper-inline"
      className="flex flex-col gap-2 rounded-xl bg-puntt-neutral-gray-2 px-4 py-3"
    >
      <Text as="p" size="2" weight="medium">
        {t("askV2.home.digDeeperTitle")}
      </Text>
      <DigDeeperBody card={card} />
      <Button
        size="1"
        variant="soft"
        data-testid="ask-v2-expand-sidebar"
        onClick={onExpand}
      >
        {t("askV2.home.expandSidebar")}
      </Button>
    </section>
  );
}

export function DigDeeperBody({ card }: { card: AskPunttActionCard }) {
  const { t } = useTranslation("ui");

  return (
    <div className="flex flex-col gap-2" data-testid="ask-v2-dig-deeper-body">
      <Text as="p" size="2" weight="medium">
        {card.title}
      </Text>
      <Text as="p" size="2">
        <span className="font-medium">{t("askV2.home.why")}: </span>
        {card.rationale}
      </Text>
      <Text as="p" size="2">
        <span className="font-medium">{t("askV2.home.impact")}: </span>
        {card.impact}
      </Text>
      {card.basedOn.length > 0 ? (
        <Text as="p" size="2" color="gray">
          <span className="font-medium">{t("askV2.home.basedOn")}: </span>
          {card.basedOn.join(" · ")}
        </Text>
      ) : null}
    </div>
  );
}
